import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { RouterLink } from '@angular/router';
import { Bau365DataAccessFairDataModule } from '@planone/bau365/data-access-fair-data';
import { Bau365FeatureBreadcrumbModule } from '@planone/bau365/feature-breadcrumb';
import { Bau365FeatureProductsSharedModule } from '@planone/bau365/feature-products';
import { Bau365FeatureUserProfileSharedModule } from '@planone/bau365/feature-user-profile';
import { Bau365FeatureWatchlistSharedModule } from '@planone/bau365/feature-watchlist';
import { SharedDataAccessSwiperModule } from '@planone/shared/data-access-swiper';
import { SharedUiElementsModule } from '@planone/shared/ui-elements';
import { SharedUtilPipelinesModule } from '@planone/shared/util-pipelines';
import { SharedUiSwiperModule } from '@planone/shared-feature-swiper';

import { SectionPostExhibitorInfoComponent } from './page-post-details/section-exhibitor-info/section-exhibitor-info.component';
import { SectionPostGalleryComponent } from './page-post-details/section-gallery/section-gallery.component';
import { SectionPostHeaderComponent } from './page-post-details/section-header/section-header.component';
import { SectionPostInfoComponent } from './page-post-details/section-info/section-info.component';
import { SectionPostMediaComponent } from './page-post-details/section-media/section-media.component';
import { SectionPostPostReferencesComponent } from './page-post-details/section-post-references/section-post-references.component';
import { SectionPostProductReferencesComponent } from './page-post-details/section-product-references/section-product-references.component';
import { PostCardComponent } from './post-card/post-card.component';
import { PostCardListComponent } from './post-card-list/post-card-list.component';

@NgModule({
  imports: [
    CommonModule,
    SharedUiElementsModule,
    Bau365DataAccessFairDataModule,
    Bau365FeatureBreadcrumbModule,
    Bau365FeatureWatchlistSharedModule,
    Bau365FeatureUserProfileSharedModule,
    MatIconModule,
    SharedUtilPipelinesModule,
    SharedDataAccessSwiperModule,
    SharedUiSwiperModule,
    Bau365FeatureProductsSharedModule,
    MatTabsModule,
    MatButtonModule,
    RouterLink,
  ],
  declarations: [
    SectionPostHeaderComponent,
    SectionPostGalleryComponent,
    SectionPostInfoComponent,
    SectionPostMediaComponent,
    SectionPostExhibitorInfoComponent,
    SectionPostProductReferencesComponent,
    SectionPostPostReferencesComponent,
    PostCardComponent,
    PostCardListComponent,
  ],
  exports: [
    SectionPostHeaderComponent,
    SectionPostGalleryComponent,
    SectionPostInfoComponent,
    SectionPostMediaComponent,
    SectionPostExhibitorInfoComponent,
    SectionPostProductReferencesComponent,
    SectionPostPostReferencesComponent,
    PostCardComponent,
    PostCardListComponent,
  ],
})
export class Bau365FeaturePostsSharedModule {}
